Namespace 'Common.Sessions'

class Common.Sessions.SharingDropdown extends Backbone.View
  template: JST['backbone/templates/common/sessions/sharing_dropdown']

  initialize: ({session}) ->
    @session = session

  render: =>
    @$el.html(@template(
      url: @_sharedSession().get('url')
    ))
    @$('#edit-shared-session').click(@_shareSession)
    @$('#stop-sharing-session').click(@_onClickStopSharing)
    @$('#copy-shared-session-url').click(@_copySharedSessionUrl)
    @

  _sharedSession: =>
    @session.sharedSession

  _shareSession: =>
    sharedSessionModal = new Common.Sessions.SharedSessionModal session: @session
    sharedSessionModal.render()

  _onClickStopSharing: =>
    swal
      title: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_confirmation')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_yes')
      cancelButtonText: I18n.t('monitoring.dashboard.session_sharing.stop_sharing_no')
      closeOnConfirm: true
      customClass: 'common'
      => @session.deleteSharedSession()

  _copySharedSessionUrl: =>
    input = @$el.find('#shared-session-url')[0]
    input.select()
    document.execCommand('copy')
